var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 62,
    viewBox: "0 0 92 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.7891 61.0103C86.7891 50.1921 82.4917 39.8171 74.842 32.1675C67.1924 24.5179 56.8172 20.2202 45.999 20.2202C35.1808 20.2202 24.8059 24.5179 17.1562 32.1675C9.50664 39.8171 5.20898 50.1921 5.20898 61.0103H86.7891Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5488 60.9901H21.2988V25.3501L15.5488 18.5801V60.9901Z",
    fill: "white",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2891 60.98H27.0391L27.0391 25.3501H21.2891L21.2891 60.98Z",
    fill: "white",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2988 18.5801H15.5488L21.2988 25.3501H27.0488L21.2988 18.5801Z",
    fill: "white",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9203 39.2598H52.8203L53.4103 9.5498H54.4903L54.9903 30.1698L54.9203 39.2598Z",
    fill: "white",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9495 6.61059C52.6405 6.55505 51.341 6.85536 50.1895 7.48022V8.94067C51.362 9.51325 52.6495 9.81079 53.9543 9.81079C55.2592 9.81079 56.5467 9.51325 57.7192 8.94067V7.47045C56.5636 6.84777 55.2608 6.55066 53.9495 6.61059Z",
    fill: "white",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9491 1.1001L53.6191 6.6101H53.9491H54.2891L53.9491 1.1001Z",
    fill: "white",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9491 1.75994C54.1755 1.75994 54.3591 1.57638 54.3591 1.34994C54.3591 1.1235 54.1755 0.939941 53.9491 0.939941C53.7226 0.939941 53.5391 1.1235 53.5391 1.34994C53.5391 1.57638 53.7226 1.75994 53.9491 1.75994Z",
    fill: "white",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8191 18.77H58.2891V54.54H63.8191V18.77Z",
    fill: "white",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3386 18.77H63.8086V54.54H69.3386V18.77Z",
    fill: "white",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8196 17.4502H60.5996V18.7702H63.8196V17.4502Z",
    fill: "white",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0396 4.56982L60.5996 5.60983V17.4498H61.0396H61.4696V5.60983L61.0396 4.56982Z",
    fill: "white",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5884 10.7798L66.1484 11.8198V17.4498H66.5884H67.0284V11.8198L66.5884 10.7798Z",
    fill: "white",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0286 17.4502H63.8086V18.7702H67.0286V17.4502Z",
    fill: "white",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4492 60.9898H70.6992V35.2898L76.4492 28.5098V60.9898Z",
    fill: "#FFF6E7",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6992 35.29H64.9492V60.99H70.6992V35.29Z",
    fill: "#FFF6E7",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6992 28.5098H76.4492L70.6992 35.2898H64.9492L70.6992 28.5098Z",
    fill: "#FFF6E7",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1294 12.9302H38.8594V60.9702H47.1294V12.9302Z",
    fill: "#E8ECFF",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6587 12.9302H35.3887V60.9702H43.6587V12.9302Z",
    fill: "#E8ECFF",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3291 27.1201H36.3691V60.9901H39.3291V27.1201Z",
    fill: "#5473CC",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3687 60.9901H29.2188V32.0901L36.3687 27.1201V60.9901Z",
    fill: "#708BE6",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3691 27.1201L32.7891 29.6101V60.9901H36.3691V27.1201Z",
    fill: "#708BE6",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3191 48.7002H44.3691V54.8802H50.3191V48.7002Z",
    fill: "#FFF6E7",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6602 30.1699V48.6999V49.9999V54.2299H50.3202V49.9999V48.6999V30.1699H43.6602Z",
    fill: "#FFF6E7",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3193 54.8799H54.2793V48.6997H50.3193V54.8799Z",
    fill: "white",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3203 30.1699V48.6999V50.6599V54.2299H54.9903V50.6599V48.6999V30.1699H50.3203Z",
    fill: "white",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0898 30.1704L49.2297 26.7402L53.3699 30.1704H45.0898Z",
    fill: "#FFF6E7",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1895 30.1704L49.1895 26.7402L53.3293 30.1704H50.1895Z",
    fill: "white",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1484 48.1396H62.8184V38.3198H58.1484V48.1396Z",
    fill: "#5473CC",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5586 38.3101V53.8601V54.2301V60.9901H58.1486V54.2301V53.8601V38.3101H51.5586Z",
    fill: "#708BE6",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1484 60.9897H62.8184V53.8599H58.1484V60.9897Z",
    fill: "#708BE6",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0586 38.3203L57.1887 35.1904L61.3286 38.3203H53.0586Z",
    fill: "#708BE6",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1484 38.3203L57.1484 35.1904L61.2883 38.3203H58.1484Z",
    fill: "#5473CC",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3486 48.1099H54.8086V60.9899H65.3486V48.1099Z",
    fill: "white",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3203 60.98V49.1401H55.8501V60.98H64.3203Z",
    fill: "#E8ECFF",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3589 60.9897H70.709V48.1099H65.3589V60.9897Z",
    fill: "#EBECED",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7087 50.2598H53.1387V60.9798H56.7087V50.2598Z",
    fill: "#E8ECFF",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M56.71 60.9902H58.6699V50.27H56.71V60.9902Z",
    fill: "#CAD4EF",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2401 53.8599H31.3301V60.9899H46.2401V53.8599Z",
    fill: "white",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M45 60.99V55.1001H32.5698V60.99H45Z",
    fill: "#85A1F8",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5692 53.8599H46.1992V60.9899H51.5692V53.8599Z",
    fill: "#EBECED",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0292969 60.9902H91.9693",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1602 8.20996H57.6502",
    stroke: "#252122",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.68641759284b5f6bd37f1a357c7f8532.svg";
export { ForwardRef as ReactComponent };